export default __webpack_public_path__ + "static/media/23_thumbnail.c6ce5025.JPG";